import React, { Component } from 'react'
import {Form, Select, Button} from 'semantic-ui-react';

class RoundChanger extends Component {
  constructor(props){
    super(props)

    let options = this.props.rounds.map((item) => 
      ({
        key: item.round_number,
        text: item.name,
        value: item.id
      }) 
      )
    this.state = {
      options: options,
      value:''
    }
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(){
    this.props.handleChangeRound(this.state.value)
  }

  handleChange(e, data){
    this.setState({value: data.value })
  }
  render(){

    const {value} = this.state
    return (
      <Form onSubmit={this.handleSubmit}>
        <Form.Field 
        control={Select} 
        options={this.state.options} 
        label={{ children: 'Change Round', htmlFor: 'form-select-control-round' }}
        placeholder='Round'
        value={value}
        onChange={this.handleChange}
        />
        <Form.Field 
        control={Button}
        content="Apply"/>
      </Form>
      
    )
  }
}

export default RoundChanger;




// WEBPACK FOOTER //
// ./src/components/admin/RoundChanger.js